// extracted by css-extract-rspack-plugin
export default {"root":"root-C6lCdb text-sm-medium","total":"total-zIZiIM"};